import React from 'react';
import styled from 'styled-components';

import { SettingsGrid } from 'settings/ui/atoms';
import SettingsPage from 'settings/ui/components/SettingsPage';
import SubscriptionSettingsComp from 'settings/ui/components/SubscriptionSettings';
import { CancelFlow } from 'settings/ui/components/BillingInfo';

function SubscriptionPage() {
  return (
    <SettingsPage scrollTop>
      <SettingsGrid>
        <CancelFlowWrapper />
        <SubscriptionSettings />
      </SettingsGrid>
    </SettingsPage>
  );
}

const CancelFlowWrapper = styled(CancelFlow)`
  grid-column: -1 / 1;
`;

const SubscriptionSettings = styled(SubscriptionSettingsComp)`
  grid-column: -1 / 1;
`;

export default SubscriptionPage;
